"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListHintItem = exports.ListItem = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./list.sass");

var List = function List(_ref) {
  var className = _ref.className,
      twoCols = _ref.twoCols,
      children = _ref.children;
  var icons = !!_react.default.Children.toArray(children).find(function (child) {
    return child.props && !!child.props.Icon;
  });
  return _react.default.createElement("ol", {
    className: (0, _classnames.default)('list', className, {
      'list--icons': icons,
      'list--twoCols': twoCols
    })
  }, children);
};

List.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.any,
  twoCols: _propTypes.default.bool
} : {};
var _default = List;
exports.default = _default;

var ListItem = function ListItem(_ref2) {
  var className = _ref2.className,
      Icon = _ref2.Icon,
      children = _ref2.children,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["className", "Icon", "children"]);
  return _react.default.createElement("li", (0, _extends2.default)({
    className: (0, _classnames.default)('list-item', className)
  }, props), Icon && _react.default.createElement(Icon, {
    className: "list-item-icon"
  }), children);
};

exports.ListItem = ListItem;
ListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.any,
  Icon: _propTypes.default.func
} : {};

var ListHintItem = function ListHintItem(_ref3) {
  var name = _ref3.name,
      text = _ref3.text,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["name", "text"]);
  return _react.default.createElement(ListItem, props, _react.default.createElement("div", {
    className: "hint"
  }, name), _react.default.createElement("strong", null, text));
};

exports.ListHintItem = ListHintItem;
ListHintItem.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.any,
  Icon: _propTypes.default.func,
  name: _propTypes.default.node,
  text: _propTypes.default.node
} : {};